import { render, staticRenderFns } from "./miscInvestmentTransaction.vue?vue&type=template&id=4fc36725&"
import script from "./miscInvestmentTransaction.vue?vue&type=script&lang=js&"
export * from "./miscInvestmentTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports